const historicalResultsTableColumnMap = new Map<string, string>([
  ["Series ID", "testSeriesLabel"],
  ["Substrate", "firstSubstrateSample"],
  ["Substrate 2", "secondSubstrateSample"],
  ["Product", "productSample"],
  ["Test Method", "testMethodName"],
  ["Building Action", "buildingAction"],
  ["Treatment", "treatment"],
  ["Test Condition", "condition"],
  ["Completed", "completed"],
]);

export default historicalResultsTableColumnMap;
